import { render, staticRenderFns } from "./orderAnalysis.vue?vue&type=template&id=58049d2a&scoped=true"
import script from "./orderAnalysis.vue?vue&type=script&lang=js"
export * from "./orderAnalysis.vue?vue&type=script&lang=js"
import style0 from "./orderAnalysis.vue?vue&type=style&index=0&id=58049d2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58049d2a",
  null
  
)

export default component.exports